// Same `playstoreurl` column is reused for both a live website link and an
// actual Play Store link — the button label just switches based on `type`.
export function getLinkMeta(type) {
  const isApp = /mobile|app/i.test(type || "");
  return isApp
    ? { label: "Get it on Google Play", shortLabel: "Get it on Play", icon: "Smartphone" }
    : { label: "Visit Website", shortLabel: "Visit Site", icon: "ArrowUpRight" };
}
